import axios from "axios";
import environment from "utils/environment/environment";
import tokenManager from "utils/token";

const requestApiFile = (url, method, payload) => {
  const data = payload;
  const { getToken } = tokenManager();
  const token = getToken();
  const headers = {
    Accept: "application/json",
    ...(token && { authorization: `${token}` }),
  };

  return axios({
    url: `${environment.rootApi}/api${url}`,
    headers,
    method,
    data,
  });
};

export default requestApiFile;
